import type { AnyNode } from "@pdfking/forms"
import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { NullQ } from "@pdfking/structs"

import type { FileCollectionStore } from "#public"
import type { FileCtx } from "#public"
import type { ResultContext } from "#public"

import { BuildFileCtx } from "./BuildFileCtx"
import { Dispatch } from "./dispatch/Dispatch"
import { FORM_STACK } from "./dispatch/FieldLayout"

export const ImpositionForm = CreateRenderFunction({
  computed: {
    ctx(): FileCtx {
      return BuildFileCtx(this)
    },
  },
  props: {
    disabled: false,
    hidden_fields: [] as string[],
    node: undefined as AnyNode | undefined,
    staff: false,
    store: undefined as unknown as FileCollectionStore,
    view: undefined as ResultContext | undefined,
  },
  render() {
    if (NullQ(this.node?.input)) return undefined
    return (
      <div className={FORM_STACK}>
        <Dispatch ctx={this.ctx} disabled={this.disabled} node={this.node} />
      </div>
    )
  },
})
